import { render } from "./EventsList.vue?vue&type=template&id=4415f4fa&scoped=true&ts=true"
import script from "./EventsList.vue?vue&type=script&lang=ts"
export * from "./EventsList.vue?vue&type=script&lang=ts"

import "./EventsList.vue?vue&type=style&index=0&id=4415f4fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4415f4fa"]])

export default __exports__